
import React from 'react';
import './Productinform.css';
import Productinfor from '../../../imgs/Productinfor1.webp';

const Productinform = () => {
    return (
        <div className="Productinfo-wrapper">
            <h2>Product Information</h2>
            <div className="Productinfo-card">
                <img src={Productinfor} alt="Application" className="Productinfo-img" />
            </div>
        </div>
    );
};

export default Productinform;
